import React, { memo } from 'react';

const DesignContent = memo(({ activity }) => {
  return (
    <div className="flux-design-content">
      <div className="flux-design-toolbar" />
      <div className={`flux-design-canvas ${activity?.action === 'zoom' ? 'zooming' : ''}`}>
        <div className={`flux-design-shape circle ${activity?.action === 'drag' ? 'dragging' : ''}`} />
        <div className="flux-design-shape rect" />
        <div className={`flux-design-text ${activity?.action === 'click' ? 'selected' : ''}`} />
      </div>
      <div className="flux-design-panel" />
    </div>
  );
});

DesignContent.displayName = 'DesignContent';

export default DesignContent;
